import {
  Activity, Syringe, Baby, Stethoscope, Bug, Skull, Users, HeartPulse,
  CloudRain, ShieldPlus, Megaphone, Droplet, Pill,
} from "lucide-react";

export const CATEGORIES = {
  epidemic: { label: "Epidemic", icon: Activity, color: "#E63946" },
  immunisation: { label: "Immunisation", icon: Syringe, color: "#4A7C59" },
  maternity: { label: "Maternity & Neonatal", icon: Baby, color: "#1F4E79" },
  tb: { label: "TB Diagnostics", icon: Stethoscope, color: "#1F4E79" },
  malaria: { label: "Malaria", icon: Bug, color: "#F4A261" },
  snakebite: { label: "Snakebite / Antivenom", icon: Skull, color: "#E63946" },
  outreach: { label: "Outreach & Specialists", icon: Users, color: "#4A7C59" },
  srh: { label: "Sexual & Reproductive", icon: HeartPulse, color: "#1F4E79" },
  disaster: { label: "Disaster Response", icon: CloudRain, color: "#E63946" },
  infection: { label: "Infection Prevention", icon: ShieldPlus, color: "#4A7C59" },
  general: { label: "General", icon: Megaphone, color: "#57534E" },
};

export const SEVERITIES = {
  info: { label: "Info", color: "#1F4E79", bg: "#E8EEF5" },
  routine: { label: "Routine", color: "#4A7C59", bg: "#E9F1EC" },
  warning: { label: "Warning", color: "#B5631F", bg: "#FBEEDF" },
  critical: { label: "Critical", color: "#E63946", bg: "#FCE6E8" },
};

export const STOCK = {
  available: { label: "Available", color: "#4A7C59", bg: "#E9F1EC" },
  low: { label: "Low Stock", color: "#B5631F", bg: "#FBEEDF" },
  out: { label: "Out of Stock", color: "#E63946", bg: "#FCE6E8" },
};

export const INV_ICON = { antivenom: Skull, blood: Droplet, medication: Pill };

export function catMeta(slug) {
  return CATEGORIES[slug] || { label: slug, icon: Megaphone, color: "#57534E" };
}
